import React from 'react'
import Svg from './Svg'
export const SvgClipboard = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M19 2.4h-4.18C14.4 1.008 13.3 0 12 0c-1.3 0-2.4 1.008-2.82 2.4H5c-1.105 0-2 1.074-2 2.4v16.8c0 1.326.895 2.4 2 2.4h14c1.105 0 2-1.074 2-2.4V4.8c0-1.326-.895-2.4-2-2.4m-7 0c.552 0 1 .536 1 1.199S12.552 4.8 12 4.8s-1-.538-1-1.201.448-1.199 1-1.199M7 7.2h10V4.8h2v16.8H5V4.8h2v2.4z" />
  </Svg>
))
SvgClipboard.isIcon = true
export default SvgClipboard
